import '../js/base/polyfills';
import 'bootstrap';
import basketSummary from './basket-summary';
import sumBasket from './basket';
import passwordStrength from './password-strength';
import setHeaderMenu from './header';
import faqs from './faqs';
import { checkout, preventDoubleSubmit, saveOrderData, loadOrderData, clearOrderData } from './checkout';
import showHideCustomDateRange from './custom-date-range';
import productImages from './product-images';
import buyingOptions from './buying-options';
import productDescriptionTabLinks from './product-description-tab-links';
import downloadImagesTab from './download-images-tab';
import deliveryAddressAutocomplete from './delivery-location-autocomplete';
import orderTypeCheckboxFilter from './order-type-checkbox-filter';
import handleUserFeedback from "./user-feedback";
import { deliveryOptions } from './checkout/DeliveryOptions';

const basketSummaryDiv = document.getElementById('js-basket-summary') as HTMLDivElement|null;
const basketTable = document.getElementById('js-basket-table') as HTMLTableElement|null;
const passwordStrengthMeters = document.querySelectorAll('.password-strength');
const headerMainNav = document.getElementById('js-header-main-nav') as HTMLUListElement|null;
const faqsContainer = document.getElementById('js-faqs') as HTMLDivElement|null;
const newDeliveryAddress = document.getElementById('js-use-new-delivery-location') as HTMLButtonElement|null;
const checkoutInputs = document.querySelectorAll('.js-checkout-input') as NodeListOf<HTMLInputElement>|null;
const confirmOrder = document.getElementById('js-confirm-order') as HTMLButtonElement|null;
const addOrderItemsButton = document.getElementById('js-add-order-items') as HTMLButtonElement|null;
const customDateRange = document.getElementById('js-customdaterange') as HTMLDivElement|null;
const productImageCollection = document.querySelectorAll('.js-product-image') as NodeListOf<HTMLDivElement>|null;
const buyingOptionsDivsDesktop = document.querySelectorAll('[data-buying-options-desktop]') as NodeListOf<HTMLDivElement>|null;
const buyingOptionsDivMobile = document.querySelector('[data-buying-options-mobile]') as HTMLDivElement|null;
const productDescription = document.getElementById('js-product-description') as HTMLDivElement|null;
const desktopCheckboxes = document.querySelectorAll('[data-checkbox-desktop]') as NodeListOf<HTMLInputElement>|null;
const mobileCheckboxes = document.querySelectorAll('[data-checkbox-mobile]') as NodeListOf<HTMLInputElement>|null;
const downloadSelectedButton = document.querySelectorAll('[data-download-selected-button]') as NodeListOf<HTMLButtonElement>|null;
const confirmDeleteDeliveryLocation = document.getElementById('js-delete-delivery-location') as HTMLButtonElement|null;
const logoutButtons = document.querySelectorAll('.logout-button') as NodeListOf<HTMLAnchorElement>|null;
const deliveryAddressAutocompleteInput = document.getElementById('js-address-autocomplete-search') as HTMLInputElement|null;
const orderExportOrderTypeFilter = document.getElementById('order-types-filter') as HTMLDivElement|null;
const starRatingIcons = document.querySelectorAll('[data-feedback-rating]') as NodeListOf<HTMLElement>|null;
const userFeedbackForm = document.getElementById('userFeedbackForm') as HTMLFormElement|null;
const checkoutDeliveryOptions = document.getElementById('delivery-options-container') as HTMLDivElement|null;

if (basketSummaryDiv !== null) {
    basketSummary(basketSummaryDiv);
}

if (basketTable !== null) {
    sumBasket(basketTable);
}

if (passwordStrengthMeters.length > 0) {
    passwordStrength(passwordStrengthMeters);
}

if (headerMainNav !== null) {
    setHeaderMenu(headerMainNav);
}

if (faqsContainer !== null) {
    faqs(faqsContainer);
}

if (newDeliveryAddress !== null) {
    checkout(newDeliveryAddress);
}

if (
    (checkoutInputs !== null && checkoutInputs.length > 0)
){
    loadOrderData(checkoutInputs);
    saveOrderData(checkoutInputs);
}

if (confirmOrder !== null) {
    preventDoubleSubmit(confirmOrder, 'Placing order...');
    confirmOrder.addEventListener('click', clearOrderData)
}

if (addOrderItemsButton !== null) {
    addOrderItemsButton.addEventListener(
        'click',
        evt => {
            const quantity = parseInt(addOrderItemsButton.dataset.quantity ?? '0', 10);
            const msg =
                'You are about to add ' +
                quantity +
                ' products to your basket. ' +
                'This will only add products that are currently available.';

            if (!confirm(msg)) {
                evt.preventDefault();
                evt.stopPropagation();
                return;
            }
        },
        false
    );
}

if (customDateRange !== null) {
    showHideCustomDateRange(customDateRange);
}

if (productImageCollection !== null) {
    productImages(productImageCollection);
}

if (buyingOptionsDivsDesktop !== null) {
    buyingOptionsDivsDesktop.forEach(buyingOptionsDivDesktop => {
        buyingOptions(buyingOptionsDivDesktop);
    });
}

if (buyingOptionsDivMobile !== null) {
    buyingOptions(buyingOptionsDivMobile);
}

if (productDescription !== null) {
    productDescriptionTabLinks();
}

if (desktopCheckboxes !== null && mobileCheckboxes !== null && downloadSelectedButton !== null) {
    downloadImagesTab(desktopCheckboxes, mobileCheckboxes, downloadSelectedButton);
}

if (deliveryAddressAutocompleteInput !== null) {
    deliveryAddressAutocomplete();
}

if (confirmDeleteDeliveryLocation !== null) {
    confirmDeleteDeliveryLocation.addEventListener('submit',
        evt => {
            if (!confirm('Please confirm you would like to delete the delivery location')) {
                evt.preventDefault();
                evt.stopPropagation();
                return;
            }
        });
}

if (orderExportOrderTypeFilter !== null) {
    orderTypeCheckboxFilter(orderExportOrderTypeFilter);
}

if (checkoutDeliveryOptions !== null) {
    deliveryOptions(checkoutDeliveryOptions);
}

if (userFeedbackForm !== null && starRatingIcons !== null) {
    handleUserFeedback(userFeedbackForm, starRatingIcons);
}

if (logoutButtons !== null) {
    logoutButtons.forEach(
        (btn) => btn.addEventListener('click', clearOrderData)
    )
}
